

































































































import Vue from 'vue';
import util from '@/utils';
import { Component } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import { getOrgInfo, upDateOrgInfo } from '@/api/school';
import { TManageInfo } from '@/types/views/school.d.ts';
const namespace = 'user';
@Component({})
export default class Manage extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  @State('id', { namespace }) id!: string;
  private orgInfo: TManageInfo = {
    id: -1,
    name: '',
    address: '',
    teacherNo: 0,
    contactname: '',
    contactphone: 0,
    adminemail: '',
    slogan: '',
    consultingPhone: 0,
    summary: '',
    detail: '',
    logoURL: ''
  };
  private errorTip = '';
  private action = `${process.env.VUE_APP_API}/mate/uploadMaterial/`;
  private activated() {
    this.getOrgInfo();
  }
  /**
   * @description: 获取机构信息
   * @param
   * @return:
   */
  private async getOrgInfo() {
    try {
      let res: any = await getOrgInfo({
        orgId: this.orgId,
        accountId: this.id
      });
      util.copy(this.orgInfo, res.orgInfo);
    } catch (e) {
      this.$message.error(e);
    }
  }
  /**
   * @description:
   * @param {type} 更新机构信息
   * @return:
   */

  private async handleUpdate() {
    try {
      let opt = this.orgInfo;
      await upDateOrgInfo(opt);
      this.$message.success('更新成功');
      this.getOrgInfo();
    } catch (e) {
      this.$message.error(e);
    }
  }
  showUploadDialog() {
    (this.$refs.upload as any).visible = true;
  }
  private beforeUpload(file: any) {
    if (file.type !== 'image/png') {
      this.errorTip = '图片类型不支持';
      return false;
    } else if (file.size / 1024 / 1024 > 1) {
      this.errorTip = '图片大小超过限制';
      return false;
    } else {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          let img = new Image();
          img.onload = () => {
            const rate = img.width / img.height;
            if (rate === 1 || rate === 3) {
              this.errorTip = '';
              resolve();
            } else {
              this.errorTip = '图片尺寸不匹配';
              reject();
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    }
  }
  private handleUploadSuccess(res: any) {
    this.orgInfo.logoURL = res.data;
  }
}
